var dsBridge = {};
if(typeof window != "undefined")
{
    dsBridge = require("dsbridge");
    window.xt_h5 = (dataStr) => {
        const { type } = JSON.parse(dataStr);
        if (type === "userLogin") return window.location.reload();
    };
}
const Bridge = {
    routeTo(path, params){
        if(typeof window == "undefined")
            return;
        if(!path)
            return;
        if(!params)
            params = "";
        else if(typeof params == "object")
        {
            var temp = "";
            for(let key in params)
            {
                temp = temp + key + "=" + params[key] + "&";
            }
            if(temp.length > 0)
                temp = temp.substring(0, temp.length-1);
            params = temp;
        }
        const keyMap = {
            "/account/login": 1, //登录
            "/account/register": 2, //注册
            "/deposit": 3, //充值
            "/trade/spot": 4, //现货交易
            "/futures/quanto": 5, //合约交易
            "/trade/etf": 6, //ETF交易
            "/super-partner": 7, //超级合伙人
            "/xt-starter": 8, //LaunchPad活动页
            "/kyc": 9, //实名认证
            "/futures/usd-m/history-record": 10, //合约资金流水
            "/futures/usd-m": 21, //合约U本位交易
            "/futures/coin-m": 22 //合约币本位交易跳转
        };
        try {
            if (dsBridge.hasNativeMethod("appRoute")) {
                //新版本
                dsBridge.call("appRoute", {path,params});
            } else {
                if (!keyMap[path]) return message.error("please upgrade");
                //老版本
                const send = JSON.stringify({
                    type: "routeTo",
                    params: { key: keyMap[path] }
                });
                if (IsIos) {
                    window.webkit.messageHandlers.xt_h5.postMessage(send);
                } else {
                    window.android.xt_h5(send);
                }
            }
        } catch (e) {
            console.error("【logErr】api_app.routeTo：%o", e);
        }
    },
    share(imageBase64){
        if(typeof window == "undefined")
            return;
        try {
            if (dsBridge.hasNativeMethod("share")) {
                dsBridge.call("share", { imageBase64 }, () => {});
            } else {
                const send = JSON.stringify({
                    type: "share",
                    params: { img: imageBase64 }
                });
                if (IsIos) {
                    window.webkit.messageHandlers.xt_h5.postMessage(send);
                } else {
                    window.android.xt_h5(send);
                }
            }
        } catch (e) {
            console.error("【logErr】api_app.share：%o", e);
        }
    },
    getToken(){
        if(typeof window == "undefined")
            return;
        try {
            if (dsBridge.hasNativeMethod("appToken")) {
                return dsBridge.call("appToken");
            }
        } catch (e) {
            console.error("【logErr】getToken：%o", e);
        }
        return "";
    },
    getVersion(){
        if(typeof window == "undefined")
            return;
        try {
            if (dsBridge.hasNativeMethod("jsBridgeVersion")) {
                return dsBridge.call("jsBridgeVersion");
            }
        } catch (e) {
            console.error("【logErr】getVersion：%o", e);
        }
        return "";
    },
    call(action, data, callback){
        if(typeof window == "undefined")
            return;
        try {
            if (dsBridge.hasNativeMethod(action)) {
                return dsBridge.call(action, data, callback);
            }
        } catch (e) {
            console.error("【logErr】bridge.call：%o", e);
        }
        return "";
    }
}
export default Bridge;